/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwitchToLinkedCompanyRequest
 */
export interface SwitchToLinkedCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchToLinkedCompanyRequest
     */
    targetCompanyId: string;
}

/**
 * Check if a given object implements the SwitchToLinkedCompanyRequest interface.
 */
export function instanceOfSwitchToLinkedCompanyRequest(value: object): value is SwitchToLinkedCompanyRequest {
    if (!('targetCompanyId' in value) || value['targetCompanyId'] === undefined) return false;
    return true;
}

export function SwitchToLinkedCompanyRequestFromJSON(json: any): SwitchToLinkedCompanyRequest {
    return SwitchToLinkedCompanyRequestFromJSONTyped(json, false);
}

export function SwitchToLinkedCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchToLinkedCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'targetCompanyId': json['targetCompanyId'],
    };
}

  export function SwitchToLinkedCompanyRequestToJSON(json: any): SwitchToLinkedCompanyRequest {
      return SwitchToLinkedCompanyRequestToJSONTyped(json, false);
  }

  export function SwitchToLinkedCompanyRequestToJSONTyped(value?: SwitchToLinkedCompanyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetCompanyId': value['targetCompanyId'],
    };
}

